<app-report-shell
  [user]="user"
  [currentTime]="''"
  [sidebarCollapsed]="sidebarCollapsed"
  [mobileSidebarOpen]="mobileSidebarOpen"
  (menuToggle)="handleMenuToggle()"
  (closeMobileSidebar)="closeMobileSidebar()"
>
  <main class="generation-details-page">
    <section class="generation-details-page__panel app-card">
      <div class="generation-details-page__panel-header">
        <div class="generation-details-page__heading-copy">
          <h2 class="app-title-serif">Generation Details</h2>
        </div>

      </div>

      <div class="generation-details-page__panel-body">
        <div class="generation-details-page__filters-row">
          

          <form class="generation-details-filters contact d-flex" [formGroup]="filtersForm">
          
              <label class="app-form-field generation-details-filters__field">
              <span class="app-form-label">Select Date</span>
              <div class="generation-details-filters__input-shell">
                @if (isBsDateMode) {
                  <button type="button" class="app-form-input generation-details-filters__date-input generation-details-filters__date-display" aria-haspopup="dialog" [attr.aria-expanded]="bsCalendarOpen" (click)="openBsDatePicker()">{{ getDateControlValue() }}</button>
                  @if (bsCalendarOpen) {
                    <dialog class="generation-details-bs-calendar" open aria-label="Nepali calendar date picker" appClickOutside (appClickOutside)="closeBsDatePicker()" (mousedown)="$event.stopPropagation()">
                      <div class="generation-details-bs-calendar__header"><button type="button" aria-label="Previous month" (click)="shiftBsCalendarMonth(-1)">‹</button><strong>{{ bsCalendarMonth?.bs_month_name || 'Nepali Calendar' }} {{ bsCalendarMonth?.bs_year || '' }}</strong><button type="button" aria-label="Next month" (click)="shiftBsCalendarMonth(1)">›</button></div>
                      <div class="generation-details-bs-calendar__weekdays">@for (weekday of bsCalendarWeekdays; track weekday) { <span>{{ weekday }}</span> }</div>
                      @if (bsCalendarLoading) { <div class="generation-details-bs-calendar__loading">Loading calendar...</div> } @else { <div class="generation-details-bs-calendar__grid">@for (cell of (bsCalendarMonth?.cells || []); track cell.bs_date) { <button type="button" [class.is-muted]="!cell.in_current_month" [class.is-selected]="cell.is_selected" [class.is-today]="cell.is_today" (click)="selectBsCalendarCell(cell)">{{ cell.bs_date_label }}</button> }</div> }
                    </dialog>
                  }
                } @else {
                  <input class="app-form-input generation-details-filters__date-input" type="date" formControlName="date" />
                }
              </div>
            </label>
            @if (showSubstationFilter) {
            <label class="app-form-field generation-details-filters__field" for="generationDetailsSubstation">
                <span class="app-form-label">Select Generator</span>
                <div class="generation-details-filters__select-shell">
                  <p-autocomplete
                    inputId="generationDetailsSubstation"
                    [(ngModel)]="substationSearchTerm"
                    [ngModelOptions]="{ standalone: true }"
                    [dropdown]="true"
                    size="compact"
                    [suggestions]="filteredSubstationOptions"
                    placeholder="Select Generator"
                    (completeMethod)="onSubstationSearchInput($event)"
                    (fieldBlur)="onSubstationSearchBlur()"
                  ></p-autocomplete>
                </div>
              </label>
            }
            <label class="app-form-field generation-details-filters__field">
              <span class="app-form-label">Show Values</span>
              <div class="generation-details-filters__select-shell">
                <select class="app-form-select generation-details-filters__select" formControlName="show_values">
                  <option [ngValue]="null" disabled>Select Value</option>
                  @for (option of valueOptions; track option.value) {
                    <option [value]="option.value">{{ option.label }}</option>
                  }
                </select>
                <span class="generation-details-filters__select-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M4 5h16l-6.5 7v5l-3 2v-7z"></path>
                  </svg>
                </span>
              </div>
            </label>
            <div class="generation-details-page__clear">
              <button
                type="button"
                class="app-button app-button--secondary app-filter-actions__button"
                [disabled]="isLoading || isExporting || isDownloadingTemplate || isImporting"
                (click)="clearFilters()"
              >
                Clear
              </button>
            </div>

          </form>

          <div class="generation-details-page__mode-switch" role="tablist" aria-label="Generation details mode">
            <fieldset class="generation-details-filters__toggle-fieldset">
              <legend class="generation-details-filters__toggle-legend">View mode</legend>
              <div class="generation-details-filters__toggle-group">
                <button
                  type="button"
                  class="generation-details-filters__toggle"
                  [class.generation-details-filters__toggle--active]="viewMode === 'day'"
                  (click)="handleViewModeChange('day')"
                >
                  Day
                </button>
                <button
                  type="button"
                  class="generation-details-filters__toggle"
                  [class.generation-details-filters__toggle--active]="viewMode === 'blocks'"
                  (click)="handleViewModeChange('blocks')"
                >
                  Blocks
                </button>
              </div>
            </fieldset>

            <div class="generation-details-filters__actions">
                <button
                  type="button"
                  class="app-button app-button--secondary generation-details-filters__menu-button app-action-menu-trigger"
                  [class.generation-details-filters__menu-button--open]="isGenerationActionMenuOpen"
                  [class.app-action-menu-trigger--open]="isGenerationActionMenuOpen"
                  [disabled]="isLoading || isExporting || isDownloadingTemplate || isImporting"
                  (click)="toggleGenerationActionMenu()"
                  aria-label="Open generation details Excel actions"
                >
                  <svg class="generation-details-filters__menu-icon app-action-menu-trigger__icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                    <circle cx="12" cy="5.5" r="1.5"></circle>
                    <circle cx="12" cy="12" r="1.5"></circle>
                    <circle cx="12" cy="18.5" r="1.5"></circle>
                  </svg>
                </button>

                @if (isGenerationActionMenuOpen) {
                  <div class="generation-details-filters__menu app-action-menu-panel">
                    <button
                      type="button"
                      class="app-button app-button--secondary generation-details-filters__menu-item app-action-menu-item"
                      title="Excel Download"
                      aria-label="Excel Download"
                      [disabled]="isLoading || isExporting || isDownloadingTemplate || isImporting"
                      (click)="exportGenerationDetailsData()"
                    >
                      <span class="app-action-menu-item__icon" aria-hidden="true">
                        <i class="fa-solid fa-file-export" aria-hidden="true"></i>
                      </span>
                      
                    </button>

                    <div class="generation-details-filters__submenu">
                      <button
                        type="button"
                        class="app-button app-button--secondary generation-details-filters__menu-item generation-details-filters__menu-item--submenu app-action-menu-item"
                        title="Download Template"
                        aria-label="Download Template"
                        [disabled]="isLoading || isExporting || isDownloadingTemplate || isImporting"
                      >
                        <span class="app-action-menu-item__icon" aria-hidden="true">
                          <i class="fa-solid fa-download" aria-hidden="true"></i>
                        </span>
                      </button>
                      <div class="generation-details-filters__submenu-panel">
                        <button type="button" class="generation-details-filters__menu-item" (click)="downloadGenerationDetailsTemplate('day')">
                          Download Day Template
                        </button>
                        <button type="button" class="generation-details-filters__menu-item" (click)="downloadGenerationDetailsTemplate('blocks')">
                          Download Blocks Template
                        </button>
                      </div>
                    </div>

                    <div class="generation-details-filters__submenu">
                      <button
                        type="button"
                        class="app-button app-button--primary generation-details-filters__menu-item generation-details-filters__menu-item--submenu app-action-menu-item"
                        title="Import Data"
                        aria-label="Import Data"
                        [disabled]="isLoading || isExporting || isDownloadingTemplate || isImporting"
                      >
                        <span class="app-action-menu-item__icon" aria-hidden="true">
                          <i class="fa-solid fa-file-import" aria-hidden="true"></i>
                        </span>
                      </button>
                      <div class="generation-details-filters__submenu-panel">
                        <button type="button" class="generation-details-filters__menu-item" (click)="triggerGenerationDetailsImportFilePicker(generationDetailsDayImportInput)">
                          Import Day Data
                        </button>
                        <button type="button" class="generation-details-filters__menu-item" (click)="triggerGenerationDetailsImportFilePicker(generationDetailsBlocksImportInput)">
                          Import Blocks Data
                        </button>
                      </div>
                    </div>
                  </div>
                }

                <input
                  #generationDetailsDayImportInput
                  type="file"
                  class="generation-details-filters__import-input"
                  accept=".xlsx"
                  (change)="onGenerationDetailsImportFileSelected($event, 'day')"
                />
                <input
                  #generationDetailsBlocksImportInput
                  type="file"
                  class="generation-details-filters__import-input"
                  accept=".xlsx"
                  (change)="onGenerationDetailsImportFileSelected($event, 'blocks')"
                />
            </div>
          </div>
        </div>

        <div class="generation-details-page__detail-row" aria-label="Generation details summary modes">
          <div class="generation-details-page__detail-buttons" role="tablist">
            <button
              type="button"
              class="generation-details-page__detail-button"
              [class.generation-details-page__detail-button--active]="isDetailModeActive('generation')"
              (click)="handleDetailModeChange('generation')"
            >
              <span class="generation-details-page__detail-button-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M12 3v18"></path>
                  <path d="M8 7h8"></path>
                  <path d="M8 12h8"></path>
                  <path d="M8 17h8"></path>
                </svg>
              </span>
              <span>Generation (MWh)</span>
            </button>

            @if (shouldShowRestrictedWaterLevelTab()) {
              <button
                type="button"
                class="generation-details-page__detail-button"
                [class.generation-details-page__detail-button--active]="isDetailModeActive('water-level')"
                (click)="handleDetailModeChange('water-level')"
              >
                <span class="generation-details-page__detail-button-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M12 3s4 4.5 4 8.5A4 4 0 1 1 8 11.5C8 7.5 12 3 12 3Z"></path>
                    <path d="M9.5 16.5h5"></path>
                  </svg>
                </span>
                <span>Water Level(m)</span>
              </button>
            }

          </div>
        </div>

        <div class="generation-details-page__table-wrap app-table-scroll">
          @if (viewMode === 'blocks') {
            <table class="log-sheet-table generation-details-table generation-details-table--blocks">
              <thead>
                <tr>
                  <th class="log-sheet-table__sticky-column log-sheet-table__header--title-case" rowspan="2" scope="col">
                    <span>Source / Hour</span>
                  </th>
                  @for (group of blockGroups; track trackByBlockGroup($index, group)) {
                    <th
                      [attr.colspan]="group.span"
                      scope="colgroup"
                      [class]="'generation-details-table__band generation-details-table__band--' + group.period"
                    >
                      {{ getPeriodTitle(group.period) }}
                    </th>
                  }
                  <th class="log-sheet-table__summary-cell log-sheet-table__summary-cell--actual log-sheet-table__header--title-case" rowspan="2" scope="col">Generation(MWh)</th>
                </tr>
                <tr>
                  @for (block of blockColumns; track trackByBlock($index, block)) {
                    <th scope="col" [class]="'log-sheet-table__hour-cell log-sheet-table__hour-cell--' + block.period">{{ block.label }}</th>
                  }
                </tr>
              </thead>
              <tbody>
                @if (isLoading) {
                  <tr>
                    <td [attr.colspan]="getBlocksColspan()" class="log-sheet-page__empty-state">Loading generation details data...</td>
                  </tr>
                } @else if (rows.length) {
                  @for (row of rows; track trackByRow($index, row)) {
                    @if (isHierarchyTotalRow(row)) {
                      <tr
                        [class]="'log-sheet-table__hierarchy-row log-sheet-table__hierarchy-row--' + row.row_kind + ' generation-details-table__hierarchy-row generation-details-table__hierarchy-row--' + row.row_kind"
                        [class.generation-details-table__hierarchy-row--footer-summary]="row.row_key?.startsWith('footer-') === true"
                      >
                        <td class="log-sheet-table__sticky-column">
                          <div [class]="'log-sheet-table__station log-sheet-table__station--total log-sheet-table__station--level-' + (row.row_level ?? 0)">
                            @if (hasHierarchyChildren(row)) {
                              <button
                                type="button"
                                class="log-sheet-table__hierarchy-toggle"
                                [attr.aria-label]="(isHierarchyExpanded(row) ? 'Collapse' : 'Expand') + ' ' + row.station_name"
                                (click)="toggleHierarchyRow(row); $event.stopPropagation()"
                              >
                                {{ isHierarchyExpanded(row) ? '−' : '+' }}
                              </button>
                            } @else {
                              <span class="log-sheet-table__hierarchy-toggle log-sheet-table__hierarchy-toggle--placeholder" aria-hidden="true"></span>
                            }
                            @if (
                              row.row_kind === 'interruption-line' ||
                              row.row_kind === 'interruption-substation' ||
                              row.row_kind === 'power-thermal-generator' ||
                              row.row_kind === 'power-water-level-generator' ||
                              row.row_kind === 'power-kabeli-corridor-generator' ||
                              row.row_kind === 'power-small-generator'
                            ) {
                              <span>{{ row.station_name }}</span>
                            } @else {
                              <strong>{{ row.station_name }}</strong>
                            }
                          </div>
                        </td>
                        @for (cell of row.blocks; track cell.block_no) {
                          <td
                            [class]="'log-sheet-table__hour-cell log-sheet-table__hour-cell--' + cell.period"
                            [class.log-sheet-table__hour-cell--edited]="isEditedCell(cell)"
                            [class.log-sheet-table__hour-cell--edited-admin]="isAdminEditedCell(cell)"
                            [class.log-sheet-table__hour-cell--edited-user]="isUserEditedCell(cell)"
                          >
                            <ng-container
                              [ngTemplateOutlet]="generationDetailsReadOnlyCellTemplate"
                              [ngTemplateOutletContext]="{ $implicit: cell, showEmptyState: false }"
                            ></ng-container>
                          </td>
                        }
                        <td class="log-sheet-table__summary-cell log-sheet-table__summary-cell--actual">{{ getRowGenerationText(row) }}</td>
                      </tr>
                    } @else {
                      <ng-container
                        [ngTemplateOutlet]="generationDetailsBlocksRowTemplate"
                        [ngTemplateOutletContext]="{ $implicit: row }"
                      ></ng-container>
                    }
                  }
                } @else {
                  <tr>
                    <td [attr.colspan]="getBlocksColspan()" class="log-sheet-page__empty-state">
                      <span class="log-sheet-page__empty-text">No generation data found for the selected filters</span>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
 
          } @else {
            <table class="log-sheet-table generation-details-table generation-details-table--day">
              <thead>
                <tr>
                  <th class="log-sheet-table__sticky-column log-sheet-table__header--title-case" scope="col">
                    <span>Source / Hour</span>
                  </th>
                  <th class="generation-details-table__day-total-header log-sheet-table__header--title-case" scope="col">Total ({{ getValueModeLabel() }})</th>
                </tr>
              </thead>
              <tbody>
                @if (isLoading) {
                  <tr>
                    <td [attr.colspan]="getDayColspan()" class="log-sheet-page__empty-state">Loading generation details data...</td>
                  </tr>
                } @else if (rows.length) {
                  @for (row of rows; track trackByRow($index, row)) {
                    @if (isHierarchyTotalRow(row)) {
                      <tr
                        [class]="'log-sheet-table__hierarchy-row log-sheet-table__hierarchy-row--' + row.row_kind + ' generation-details-table__hierarchy-row generation-details-table__hierarchy-row--' + row.row_kind"
                        [class.generation-details-table__hierarchy-row--footer-summary]="row.row_key?.startsWith('footer-') === true"
                      >
                        <td class="log-sheet-table__sticky-column">
                          <div [class]="'log-sheet-table__station log-sheet-table__station--total log-sheet-table__station--level-' + (row.row_level ?? 0)">
                            @if (hasHierarchyChildren(row)) {
                              <button
                                type="button"
                                class="log-sheet-table__hierarchy-toggle"
                                [attr.aria-label]="(isHierarchyExpanded(row) ? 'Collapse' : 'Expand') + ' ' + row.station_name"
                                (click)="toggleHierarchyRow(row); $event.stopPropagation()"
                              >
                                {{ isHierarchyExpanded(row) ? '−' : '+' }}
                              </button>
                            } @else {
                              <span class="log-sheet-table__hierarchy-toggle log-sheet-table__hierarchy-toggle--placeholder" aria-hidden="true"></span>
                            }
                            <strong>{{ row.station_name }}</strong>
                          </div>
                        </td>
                        <td class="generation-details-table__sector-total-value">{{ getDayTotalText(row) }}</td>
                      </tr>
                    } @else {
                      <ng-container
                        [ngTemplateOutlet]="generationDetailsDayRowTemplate"
                        [ngTemplateOutletContext]="{ $implicit: row }"
                      ></ng-container>
                    }
                  }
                } @else {
                  <tr>
                    <td [attr.colspan]="getDayColspan()" class="log-sheet-page__empty-state">
                      <span class="log-sheet-page__empty-text">No generation data found for the selected filters</span>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          }
        </div>

        @if (viewMode === 'blocks') {
          <div class="generation-details-page__legend" aria-label="Hourly bands legend">
            <span class="log-sheet-page__legend-item">
              <span class="log-sheet-page__legend-swatch log-sheet-page__legend-swatch--morning" aria-hidden="true"></span>
              <span>Morning (00:00 - 07:00)</span>
            </span>
            <span class="log-sheet-page__legend-item">
              <span class="log-sheet-page__legend-swatch log-sheet-page__legend-swatch--day" aria-hidden="true"></span>
              <span>Day (08:00 - 15:00)</span>
            </span>
	            <span class="log-sheet-page__legend-item">
	              <span class="log-sheet-page__legend-swatch log-sheet-page__legend-swatch--night" aria-hidden="true"></span>
	              <span>Night (16:00 - 23:00)</span>
	            </span>
	            <span class="log-sheet-page__legend-item">
	              <span class="log-sheet-page__legend-swatch log-sheet-page__legend-swatch--admin-edited-cell" aria-hidden="true"></span>
	              <span>Admin Edited Cell</span>
	            </span>
	            <span class="log-sheet-page__legend-item">
	              <span class="log-sheet-page__legend-swatch log-sheet-page__legend-swatch--user-edited-cell" aria-hidden="true"></span>
	              <span>Generator/Substation Edited Cell</span>
	            </span>
	            <span class="log-sheet-page__legend-item">
	              <span class="log-sheet-page__legend-swatch log-sheet-page__legend-swatch--small-generator" aria-hidden="true"></span>
	              <span>Other small generators</span>
            </span>
          </div>
        }
      </div>
    </section>
    <ng-template #generationDetailsBlocksRowTemplate let-row>
      <tr
        data-generation-details="blocks-row"
        class="log-sheet-table__hierarchy-row log-sheet-table__hierarchy-row--data generation-details-table__hierarchy-row generation-details-table__hierarchy-row--data"
        [class.generation-details-table__hierarchy-row--footer-summary]="row.row_key?.startsWith('footer-') === true"
        [class.generation-details-table__hierarchy-row--power-small-generator]="isHydroSmallPowerRow(row)"
      >
        <td class="log-sheet-table__sticky-column">
          <div [class]="'log-sheet-table__station log-sheet-table__station--level-' + (row.row_level ?? 0)" data-generation-details="station-label">
            @if (row.row_kind === 'generation-total') {
              <strong>{{ row.station_name }}</strong>
            } @else if (hasHierarchyChildren(row)) {
              <button
                type="button"
                class="log-sheet-table__hierarchy-toggle"
                [attr.aria-label]="(isHierarchyExpanded(row) ? 'Collapse' : 'Expand') + ' ' + row.station_name"
                (click)="toggleHierarchyRow(row)"
              >
                {{ isHierarchyExpanded(row) ? '−' : '+' }}
              </button>
              <strong>{{ row.station_name }}</strong>
            } @else {
              <span class="log-sheet-table__hierarchy-toggle log-sheet-table__hierarchy-toggle--placeholder" aria-hidden="true"></span>
              <strong>{{ row.station_name }}</strong>
            }
          </div>
        </td>
        @for (cell of row.blocks; track cell.block_no) {
          <td
            [attr.data-generation-details-cell]="cell.block_no"
            [class]="'log-sheet-table__hour-cell log-sheet-table__hour-cell--' + cell.period"
            [class.log-sheet-table__hour-cell--edited]="isEditedCell(cell)"
            [class.log-sheet-table__hour-cell--edited-admin]="isAdminEditedCell(cell)"
            [class.log-sheet-table__hour-cell--edited-user]="isUserEditedCell(cell)"
            [class.log-sheet-table__hour-cell--editable]="isCellInteractive(row, cell)"
            [class.log-sheet-table__hour-cell--editing]="isEditingCell(row.station_id, cell.block_no)"
            (dblclick)="beginCellEdit(row, cell)"
          >
            @if (isEditingCell(row.station_id, cell.block_no)) {
              <input
                class="log-sheet-table__editor"
                type="number"
                step="1"
                inputmode="numeric"
                [value]="cellDraftValue"
                (input)="handleCellInput($event)"
                (blur)="handleCellBlur(row, cell)"
                (keydown)="handleCellKeydown($event, row, cell)"
              />
            } @else {
              <ng-container
                [ngTemplateOutlet]="generationDetailsReadOnlyCellTemplate"
                [ngTemplateOutletContext]="{ $implicit: cell, showEmptyState: true }"
              ></ng-container>
            }
          </td>
        }
        <td class="log-sheet-table__summary-cell log-sheet-table__summary-cell--actual">{{ getRowGenerationText(row) }}</td>
      </tr>
    </ng-template>

    <ng-template #generationDetailsReadOnlyCellTemplate let-cell let-showEmptyState="showEmptyState">
      <div class="log-sheet-table__cell-content">
        <span
          class="log-sheet-table__cell-text"
          [class.log-sheet-table__cell-text--empty]="showEmptyState && (cell.value === null || cell.value === undefined)"
        >
          {{ getCellText(cell) }}
        </span>
        @if (cell.remarks) {
          <button type="button" class="log-sheet-table__remark-indicator" [attr.aria-label]="'Saved remarks for block ' + cell.label">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <circle cx="12" cy="12" r="9"></circle>
              <path d="M12 8h.01"></path>
              <path d="M11 11h1v5h1"></path>
            </svg>
            <span class="log-sheet-table__remark-tooltip" role="tooltip">{{ cell.remarks }}</span>
          </button>
        }
      </div>
    </ng-template>

    <ng-template #generationDetailsDayRowTemplate let-row>
      <tr
        data-generation-details="day-row"
        class="log-sheet-table__hierarchy-row log-sheet-table__hierarchy-row--data generation-details-table__hierarchy-row generation-details-table__hierarchy-row--data"
        [class.generation-details-table__hierarchy-row--footer-summary]="row.row_key?.startsWith('footer-') === true"
        [class.generation-details-table__hierarchy-row--power-small-generator]="isHydroSmallPowerRow(row)"
      >
        <td class="log-sheet-table__sticky-column">
          <div [class]="'log-sheet-table__station log-sheet-table__station--level-' + (row.row_level ?? 0)" data-generation-details="station-label">
            <strong>{{ row.station_name }}</strong>
          </div>
        </td>
        <td
          class="generation-details-table__day-total-value"
          [class.generation-details-table__day-total-value--editable]="isDayTotalInteractive(row)"
          [class.generation-details-table__day-total-value--editing]="isEditingDayTotal(row)"
          (dblclick)="beginDayTotalEdit(row)"
        >
          @if (isEditingDayTotal(row)) {
            <input
              class="generation-details-table__day-total-editor"
              type="number"
              step="1"
              inputmode="numeric"
              [value]="cellDraftValue"
              (input)="handleCellInput($event)"
              (blur)="handleDayTotalBlur(row)"
              (keydown)="handleDayTotalKeydown($event, row)"
            />
          } @else {
            <div class="generation-details-table__day-total-display">
              <span
                class="generation-details-table__day-total-text"
                [class.generation-details-table__day-total-text--empty]="row.day_total_mwh === null || row.day_total_mwh === undefined"
              >
                {{ getDayTotalText(row) }}
              </span>
              @if (getDayRemarks(row)) {
                <button
                  type="button"
                  class="log-sheet-table__remark-indicator generation-details-table__day-total-remark"
                  [attr.aria-label]="'Saved remarks for ' + row.station_name"
                >
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <circle cx="12" cy="12" r="9"></circle>
                    <path d="M12 8h.01"></path>
                    <path d="M11 11h1v5h1"></path>
                  </svg>
                  <span class="log-sheet-table__remark-tooltip" role="tooltip">{{ getDayRemarks(row) }}</span>
                </button>
              }
            </div>
          }
        </td>
      </tr>
    </ng-template>

    <ng-template #generationDetailsRemarksModal>
      <div class="app-modal-backdrop">
        <dialog class="app-modal log-sheet-remarks-modal" open>
          <div class="log-sheet-remarks-modal__header">
            <div>
              <h3 class="app-title-serif">Edit Data</h3>
              <p>Update the selected generation value, copy the previous block value, or add remarks before saving.</p>
            </div>

            <button
              type="button"
              class="app-button app-button--icon log-sheet-remarks-modal__close"
              aria-label="Close remarks modal"
              (click)="closeRemarksModal()"
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round">
                <path d="M6 6 18 18"></path>
                <path d="M18 6 6 18"></path>
              </svg>
            </button>
          </div>

          <form [formGroup]="remarksForm" (ngSubmit)="saveRemarks()">
            <div class="log-sheet-remarks-modal__body">
              <label class="app-form-field">
                <span class="app-form-label">Data Value</span>
                <input
                  class="app-form-input"
                  type="number"
                  step="1"
                  inputmode="numeric"
                  formControlName="data_value"
                  placeholder="Enter value"
                  (input)="onEditDataValueInput($event)"
                />
              </label>

              <div class="log-sheet-remarks-modal__options">
                <label class="log-sheet-remarks-modal__option">
                  <input
                    type="checkbox"
                    formControlName="copy_previous_block_value"
                    [disabled]="arePreviousValueControlsDisabled()"
                  />
                  <span>Copy previous block value</span>
                </label>

                <label class="log-sheet-remarks-modal__option">
                  <input
                    type="checkbox"
                    formControlName="carry_over_previous_day_values"
                    [disabled]="arePreviousValueControlsDisabled()"
                  />
                  <span>Carry over previous day value</span>
                </label>
              </div>

              <label class="app-form-field">
                <span class="app-form-label">Remarks</span>
                <textarea class="app-form-input log-sheet-remarks-modal__textarea" rows="4" formControlName="remarks" placeholder="Add remarks for this value"></textarea>
              </label>
            </div>

            <div class="log-sheet-remarks-modal__footer">
              <button type="button" class="app-button app-button--ghost" (click)="closeRemarksModal()">Cancel</button>
              <button type="submit" class="app-button app-button--primary" [disabled]="isSavingCell">
                {{ isSavingCell ? 'Saving...' : 'Save Remarks' }}
              </button>
            </div>
          </form>
        </dialog>
      </div>
    </ng-template>
  </main>

  @if (remarksModalOpen) {
    <ng-container [ngTemplateOutlet]="generationDetailsRemarksModal"></ng-container>
  }
</app-report-shell>
